import { render, staticRenderFns } from "./EditProduct.vue?vue&type=template&id=eff03fd6"
import script from "./EditProduct.vue?vue&type=script&lang=js"
export * from "./EditProduct.vue?vue&type=script&lang=js"
import style0 from "./EditProduct.vue?vue&type=style&index=0&id=eff03fd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports